import booleanConverter from '@/services/import/General/booleanConverter';

export default function genenrerLogoDispositif(ligne) {
  return {
    code: ligne.codeDispositif,
    url: ligne.url,
    isLogo: booleanConverter(ligne.isLogo),
  };
}
